import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "registration-footer" }
const _hoisted_2 = {
  key: 0,
  class: "registration-footer__login"
}
const _hoisted_3 = ["data-testid"]

import { computed } from "vue";
import { AuthenticationStepType } from "@/account/models/authentication-flows";


export default /*@__PURE__*/_defineComponent({
  __name: 'registration-footer',
  props: {
    authenticationStep: {}
  },
  emits: ["nextStep", "openLoginModal"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const ctaText = computed(() => {
    switch (props.authenticationStep) {
        case "RegVerPhone":
        case "RegPinLog":
            return "Ověřit kód";
        case "RegNewPass":
            return "Uložit heslo";

        default:
            return "Pokračovat";
    }
});

const dataTestid = computed(() => {
    if (props.authenticationStep !== "RegNewPass") {
        return "continue-button";
    }
    return null;
});

const primaryClickHandler = () => {
    emit("nextStep");
};

const loginClickHandler = () => {
    emit("openLoginModal");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.authenticationStep == 'RegPersonal')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createTextVNode(" Již mám svůj účet. ")),
          _createElementVNode("a", {
            class: "registration-footer__login-btn",
            onClick: loginClickHandler
          }, "Chci se přihlásit.")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      class: "btn btn-secondary registration-footer__primary",
      "data-testid": dataTestid.value,
      onClick: primaryClickHandler
    }, _toDisplayString(ctaText.value), 9, _hoisted_3)
  ]))
}
}

})